<template>
    <div v-if="mostrar" class="modal-mask" @click.self="$emit('fechar')">
        <div class="jm margem" style="min-width: 30vw;" @click.stop>
            <h2 class="alinha-centro">Concluir pacote de trabalho</h2>
            <fieldset class="grid-1">
                <div>
                    <label>Entrega alcançada</label>
                    <textarea v-model="localEntrega.resultado_alcancado"
                        :required="!localEntrega.resultado_alcancado" placeholder="Descreva a entrega alcançada..."></textarea>
                </div>
            </fieldset>
            <div class="submit direita">
                <button type="button" class="acao-secundaria" @click="$emit('fechar')">Cancelar</button>
                <button type="button" :disabled="!localEntrega.resultado_alcancado?.trim()" @click="onSalvar">Salvar</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ModalResultadoEntrega",
    props: {
        mostrar: { type: Boolean, default: false },
        entrega: { type: Object, default: () => ({}) },
    },
    emits: ["fechar", "salvar"],
    data() {
        return {
            localEntrega: {},
        };
    },
    watch: {
        entrega: {
            handler(val) {
                this.localEntrega = val ? { ...val } : {};
            },
            immediate: true,
            deep: true,
        },
        mostrar(visivel) {
            if (visivel && this.entrega) {
                this.localEntrega = { ...this.entrega };
            }
        },
    },
    methods: {
        onSalvar() {
            if (!this.localEntrega.resultado_alcancado?.trim()) return;
            this.$emit("salvar", {
                resultado_alcancado: this.localEntrega.resultado_alcancado.trim(),
            });
        },
    },
};
</script>
